<template>
  <b-modal
    id="modal-danger"
    v-model="modalShow"
    ok-variant="danger"
    ok-title="Accept"
    modal-class="modal-normal"
    centered>
    <div class="d-block text-center mb-1">
      <p class="font-weight-bold h2">
        Make Call
      </p>
    </div>
    <div
      class="mx-auto mb-2"
      style="width: 80%;">
    </div>
    <div>
      <TextFieldInput
        v-model="phoneNumberValue"
        label="Telephone No."
        name="telephone"
      />
    </div>
    <div v-if="!isZoomEnabled">
      <SelectField
        v-model="skillId"
        :options="skillsData"
        name="Service Name"
        form-label="Service Name"
        label-option="skillName"
        return-value="skillId"
      />
    </div>
    <template #modal-footer="{ hide }">
      <div class="mx-auto">
        <b-button
          variant="primary"
          style="margin-right: 12px"
          :disabled="isSubmitting || !canSubmit"
          @click="onSubmit()">
          {{ isSubmitting ? 'Calling...' : 'Call' }}
        </b-button>
        <b-button
          variant="outline-primary"
          @click="hide">
          Cancel
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import CxOneProvider from '@/resources/CxOneProvider'
import { dialZoomPhone, ZOOM_DIAL_STATUS } from '@/utils/zoomEmbedMessage'
import { showErrorToast } from '@/utils/toast'
import SelectField from '../Form/SelectField.vue'
import TextFieldInput from '../Form/TextFieldInput2.vue'

const CxOneService = new CxOneProvider()

const ZOOM_DIAL_ERROR_MESSAGES = {
  [ZOOM_DIAL_STATUS.NOT_CONFIGURED]: 'Zoom Soft Embed URL is not configured for this environment.',
  [ZOOM_DIAL_STATUS.NOT_READY]: 'Zoom Contact Center is not ready. Please open Zoom and try again.',
  [ZOOM_DIAL_STATUS.INVALID_PHONE]: 'Please enter a valid phone number.'
}

export default {
  components: {
    TextFieldInput,
    SelectField
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    phoneNumber: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  data () {
    return {
      skillsData: [],
      skillId: null,
      isSubmitting: false
    }
  },
  computed: {
    modalShow: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    phoneNumberValue: {
      get () {
        return this.phoneNumber
      },
      set (val) {
        this.$emit('update:phoneNumber', val)
      }
    },
    isZoomEnabled () {
      return Boolean(this.$store.getters['User/user']?.zoomEnabled)
    },
    canSubmit () {
      const hasPhoneNumber = Boolean(String(this.phoneNumber ?? '').trim())
      return this.isZoomEnabled
        ? hasPhoneNumber
        : hasPhoneNumber && Boolean(this.skillId)
    }
  },
  mounted () {
    if (!this.isZoomEnabled) {
      this.getSkills()
    }
  },
  methods: {
    async getSkills () {
      try {
        const cxoneSkill = this.$store.getters['User/cxoneSkill']
        if (cxoneSkill) {
          this.skillsData = cxoneSkill
        }
      } catch (error) {
        console.error(error)
      }
    },
    async onSubmit () {
      if (!this.canSubmit || this.isSubmitting) return

      this.isSubmitting = true
      try {
        if (this.isZoomEnabled) {
          this.dialWithZoom()
        } else {
          await this.dialWithCxOne()
        }
        this.$emit('input', false)
      } catch (error) {
        console.error(error)
        showErrorToast(
          this,
          'Unable to make call',
          error?.message || 'Please check your softphone connection and try again.'
        )
      } finally {
        this.isSubmitting = false
      }
    },
    dialWithZoom () {
      const { ok, status } = dialZoomPhone(this.phoneNumber)
      if (ok) return

      throw new Error(
        ZOOM_DIAL_ERROR_MESSAGES[status]
        || 'Unable to start the Zoom call. Please try again.'
      )
    },
    async dialWithCxOne () {
      const token = this.$store.getters['User/cxoneToken']
      const sessionId = this.$store.getters['User/sessionId']
      const isLoginFromCXONE = this.$store.getters['User/isLoginFromCXONE']

      if (!token || !sessionId || !isLoginFromCXONE) {
        throw new Error('CXone is not connected. Please sign in to CXone and try again.')
      }

      const { data } = await CxOneService.dialPhone(sessionId, {
        phoneNumber: this.phoneNumber,
        skillId: this.skillId,
        parentContactId: 0
      })
      if (data && Array.isArray(data?.agentSkillAssignments)) {
        this.skillsData = data.agentSkillAssignments.filter((item) => item?.mediaTypeId === 4)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
